<!-- <div
  [style.grid-template-columns]="isSidebarToggled ? '40px 1fr' : '220px 1fr'"
  [style.grid-template-columns]="isMobileScreen ? '0px 1fr' : '40px 1fr'"
  class="grid gap-[20px] h-[100vh] p-4 bg-stone-100"
> -->
<div
  [style.grid-template-columns]="isMobileScreen ? '0px 1fr' : (isSidebarToggled ? '40px 1fr' : '220px 1fr')"
  class="grid gap-[0px] sm:gap-[20px] h-[100vh] p-4 bg-stone-100"
>
  <app-sidebar (toggleEvent)="handleToggle($event)" [isMobileSideNav]="isMobileSideNav" />
  <div class="bg-[#fff] rounded-[10px] shadow">
    <app-navbar (openMobileSideNav)="handleMobileSideNav($event)" />
    <ng-content />
  </div>
</div>
